export default __webpack_public_path__ + "static/media/opa.c172b417.svg";